import React from 'react';
import { motion } from 'framer-motion';
declare global {
  interface Window {
    fbq: (...args: unknown[]) => void;
  }
}
interface CTAButtonProps {
  children: React.ReactNode;
  className?: string;
  fullWidth?: boolean;
}
export function CTAButton({
  children,
  className = '',
  fullWidth = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (typeof window.fbq === 'function') {
      window.fbq('track', 'AddToCart');
    }
  };
  return <motion.a href="https://www.kmsinrendirse.shop/cart/add?id=51999668764955&quantity=1" onClick={handleClick} whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`
        inline-flex items-center justify-center
        bg-primary hover:bg-primary-hover text-white
        font-heading font-bold text-lg md:text-xl
        py-4 px-8 rounded-xl shadow-glow transition-colors
        ${fullWidth ? 'w-full' : ''}
        ${className}
      `} data-id="element-283">
      {children}
    </motion.a>;
}